/**
 * Validate 验证手机号
 * @param value 表单值
 * @returns {*}
 */
export const isMobile = (value) => {
  if (!(/^1[3456789]\d{9}$/.test(value))) {
    return false
  }
  return true
}
